import React, { useEffect, useState } from "react";
import {
  Navigate,
  useLocation
} from "react-router-dom";
import { supabase } from "./supabaseClient";

export default function RequireAuth({ children }) {
  const location = useLocation();
  const [supabaseSession, setSupabaseSession] = useState(undefined);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSupabaseSession(session);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSupabaseSession(session);
      }
    );
    return () => subscription.unsubscribe();
  }, []);

  if (supabaseSession === undefined) {
    return null;
  }

  const isAuthed = Boolean(supabaseSession?.access_token);

  if (!isAuthed) {
    return (
      <Navigate
        to="/auth?view=sign_in"
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
}
